import React, { Component } from "react";
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import {
  Edit,
  Delete,
  RefreshOutlined,
  CallMissedOutgoing,
  Info,
} from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  fetchSales,
  fetchItemMaster,
  fetchDetailMaster,
  fetchCustomerMaster,
  apiURL,
  fetchReferenceMaster,
} from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import { withRouter } from "../HOC/withRouter";
import SalesItemEntry from "./SalesNew2.0";
import SalesInvoiceSelection from "./SalesInvoiceSelection";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import {
  get_YMD_from_SYS,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
  validatedate_min_max,
  copyRowsAllCols,
  getRowData,
  isNumeric,
  getTaxNumFromStr,
  getRowColSum,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CustomerMaster from "./CustomerMaster";
import ReferenceMaster from "./ReferenceMaster";
import DetailMaster from "./DetailMaster";
import PaymentModeTable from "./PaymentModeTable";
import OrderSelection from "./OrderSelection";
import SalesEWayBill from "./SalesEWayBill";
import MoreInfoTextEditor from "./MoreInfoTextEditor";
import SalesE_WayBill from "./SalesE_WayBill";

class SalesEntry extends Component {
  state = {
    Company: [],
    TransactionType: [{ name: "Paid" }, { name: "Remain" }],
    BillType: [{ name: "Tax" }, { name: "Retail" }],
    Customer: [],
    CompanyList: [],
    ShipTo: [],
    ItemNameList: [],
    StoreList: [],
    PackingList: [],
    TaxNameList: [],
    BillNoList: [],
    LedgerNameList: [],
    ReferenceList: [],
    DetailList: [],
    SalesInvoiceGeneration: "",
    CustomerStateCode: "",
    CustomerData: [],
    EWayBillData: [],
    StateList: [],
    ValidUnit: [
      { FullName: "BAGS", shortName: "BAG" },
      { FullName: "BALE", shortName: "BAL" },
      { FullName: "BUNDLES", shortName: "BDL" },
      { FullName: "BUCKLES", shortName: "BKL" },
      { FullName: "BILLION OF UNITS", shortName: "BOU" },
      { FullName: "BOX", shortName: "BOX" },
      { FullName: "BOTTLES", shortName: "BTL" },
      { FullName: "BUNCHES", shortName: "BUN" },
      { FullName: "CANS", shortName: "CAN" },
      { FullName: "CUBIC METERS", shortName: "CBM" },
      { FullName: "CUBIC CENTIMETERS", shortName: "CCM" },
      { FullName: "CENTIMETERS", shortName: "CMS" },
      { FullName: "CARTONS", shortName: "CTN" },
      { FullName: "DOZENS", shortName: "DOZ" },
      { FullName: "DRUMS", shortName: "DRM" },
      { FullName: "GREAT GROSS", shortName: "GGK" },
      { FullName: "GRAMMES", shortName: "GMS" },
      { FullName: "GROSS", shortName: "GRS" },
      { FullName: "GROSS YARDS", shortName: "GYD" },
      { FullName: "KILOGRAMS", shortName: "KGS" },
      { FullName: "KILOLITRE", shortName: "KLR" },
      { FullName: "KILOMETRE", shortName: "KME" },
      { FullName: "LITRES", shortName: "LTR" },
      { FullName: "MILILITRE", shortName: "MLT" },
      { FullName: "METERS", shortName: "MTR" },
      { FullName: "METRIC TON", shortName: "MTS" },
      { FullName: "NUMBERS", shortName: "NOS" },
      { FullName: "OTHERS", shortName: "OTH" },
      { FullName: "PACKS", shortName: "PAC" },
      { FullName: "PIECES", shortName: "PCS" },
      { FullName: "PAIRS", shortName: "PRS" },
      { FullName: "QUINTAL", shortName: "QTL" },
      { FullName: "ROLLS", shortName: "ROL" },
      { FullName: "SETS", shortName: "SET" },
      { FullName: "SQUARE FEET", shortName: "SQF" },
      { FullName: "SQUARE METERS", shortName: "SQM" },
      { FullName: "SQUARE YARDS", shortName: "SQY" },
      { FullName: "TABLETS", shortName: "TBS" },
      { FullName: "TEN GROSS", shortName: "TGM" },
      { FullName: "THOUSANDS", shortName: "THD" },
      { FullName: "TONNES", shortName: "TON" },
      { FullName: "TUBES", shortName: "TUB" },
      { FullName: "US GALLONS", shortName: "UGS" },
      { FullName: "UNITS", shortName: "UNT" },
      { FullName: "YARDS", shortName: "YDS" },
    ],
    openValidUnitList: false,

    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "bint_itemsrno", label: "S.N." },
      { id: "vac_storename", label: "Store Name" },
      { id: "vac_itemname", label: "Item Name" },
      { id: "vac_hsncode", label: "HSN" },
      { id: "vac_unit", label: "Packing" },
      { id: "dec_qty", label: "Qty" },
      { id: "dec_rate", label: "Rate" },
      { id: "dec_basicamt", label: "Basic Amt" },
      { id: "dec_disper", label: "Dis (%)" },
      { id: "dec_disamt", label: "Dis Amt" },
      { id: "dec_taxable", label: "Taxable" },
      { id: "vac_taxname", label: "Tax" },
      { id: "dec_cgstamt", label: "CGST" },
      { id: "dec_sgstamt", label: "SGST" },
      { id: "dec_igstamt", label: "IGST" },
      { id: "dec_totalamt", label: "Total Amount" },
      { id: "vac_remark", label: "Remark" },
    ],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "SalesEntry:",
        actionType: "AlertResponsive",
        visiblecondition: [
          { colID: "DisableEdit", value: false, relationalOperator: "==" },
        ],
        // hide: (this.props.userPrivilege.Sales == 'R' || this.props.userPrivilege.Sales == 'W')
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "SalesEntry:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Sales == "R" ||
          this.props.userPrivilege.Sales == "W",
      },
    ],

    formData: {
      edit_salessrno: "",
      dtpDate: get_YMD_from_SYS(new Date()),
      dtpDueDate: "",
      cmbCompany: localStorage.getItem("CompanyName"),
      cmbBillType: "",
      txtBillNo: "",
      LblBillNo: "",
      cmbCustomer: "",
      cmbShipTo: "",
      txtOtherDetail: "",
      txtDiscount: "",
      txtTaxable: "",
      txtCGST: "",
      txtSGST: "",
      txtIGST: "",
      txtGrandTotal: "",
      txtTDSAmount: "",
      txtAdvPayment: "",
      txtNetPayment: "",
      txtRoundOff: "",
      cmbTransactionType: "",
      txtRemark: "",
      chkReceiptGenerated: false,
      cmbReference: "",
      dec_remainamt: "",
      txtACKno: "",
      txtACKDate: "",
      txtIRN: "",
      tblCGST: 0,
      tblSGST: 0,
      tblIGST: 0,
      subSupplyType: "",
    },
    autoResetFormData: false,

    dataLoadStatus: true,
    ARD: null,
    DRP: "",
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
    totalBeforeTaxAmt: 0,
    totalAfterTaxAmt: 0,

    columnsOtherDetail: [
      { id: "Action", label: "", focus: false },
      { id: "vac_headingvalue", label: "Headings", focus: false },
      { id: "txtFormate", label: "", focus: false },
      {
        id: "vac_value",
        label: "Values",
        type: "CtTxt",
        CtrlProps: {
          value: "",
          width: 150,
          maxLength: 20,
          focus: true,

          amountOnlyCondition: [
            {
              colID: "vac_calculation",
              value: "-",
              relationalOperator: "===",
              logicalOperator: "||",
            },
            {
              colID: "vac_calculation",
              value: "+",
              relationalOperator: "===",
              logicalOperator: "||",
            },
          ],
        },
      },
    ],
    rowsOtherDetail: [],
    rowsCountOtherDetail: 0,
    rowsPerPageOtherDetail: 10,
    Displaybtn: false,

    columnsPaymentMode: [
      // { id: "Action", label: "Search", name: "Search" },
      // { id: 'bint_srno', label: 'SR NO' },
      { id: "vac_ledgername", label: "Payment Mode Ledger" },
      {
        id: "dec_amount",
        label: "Amount",
        type: "CtTxtAmt",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "vac_chequeno",
        label: "Cheque No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "vac_referenceno",
        label: "Reference No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "dat_transactiondate",
        label: "Transaction Date",
        type: "CtDtp",
        CtrlProps: { value: "", maxLength: 20 },
      },
      {
        id: "vac_remark",
        label: "Remark",
        type: "CtMultiLineText",
        CtrlProps: { value: "", width: 120, maxLength: 100 },
      },
      { id: "vac_groupname", label: "Group Name", hide: true },
    ],
    rowsPaymentMode: [],
    rowsCountPaymentMode: 0,
    rowsPerPagePaymentMode: 5,
    DefaultEntrySettingList: [],
    PaymentData: [],
    PaymentmodeListCols: [
      "bint_acid",
      "bint_ledgercode",
      "bint_ledgeridsrno",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_company",
      "vac_firmname",
      "vac_groupheader",
      "vac_groupname",
      "vac_gstno",
      "vac_ledgername",
    ],
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Sales Entry";
    this.props.setActiveMenu("SalesEntry");
    this.ShortCut();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges,
    );
  }

  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }

  //#endregion component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "cmbBillType") {
          this.getBillNo();
        } else if (e.target.name === "cmbCustomer") {
          this.getStateCodeOFCustomer();
        } else if (
          e.target.name === "txtAdvPayment" ||
          e.target.name === "txtTDSAmount"
        ) {
          this.calNetAmount();
        } else if (e.target.name === "cmbTransactionType") {
          if (this.state.formData.cmbTransactionType === "Paid") {
            this.setState(
              {
                formData: {
                  ...this.state.formData,
                  txtAdvPayment: 0,
                  chkReceiptGenerated: false,
                },
              },
              () => {
                this.calNetAmount();
              },
            );
          }
        }
      },
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleARDonActionClick = (row) => {
    let bint_itemsrno = row.bint_itemsrno,
      vac_itemname = row.vac_itemname,
      actionName = row.actionName,
      edit_salessrno = this.state.formData.edit_salessrno,
      bint_acyear = localStorage.getItem("ACY"),
      bint_acid = localStorage.getItem("acid"),
      EditSalesItemData = [],
      CustomerStateCode = "",
      CustomerData = [];
    console.log("this.state.rows", this.state.rows);
    if (actionName === "Edit") {
      let ARD = null;
      EditSalesItemData = [
        {
          bint_itemsrno: row.bint_itemsrno,
          vac_itemname: row.vac_itemname,
          vac_hsncode: row.vac_hsncode,
          vac_unit: row.vac_unit,
          dec_qty: row.dec_qty,
          dec_rate: row.dec_rate,
          dec_basicamt: row.dec_basicamt,
          dec_disper: row.dec_disper,
          dec_disamt: row.dec_disamt,
          dec_taxable: row.dec_taxable,
          vac_taxname: row.vac_taxname,
          dec_cgstamt: row.dec_cgstamt,
          dec_sgstamt: row.dec_sgstamt,
          dec_igstamt: row.dec_igstamt,
          dec_totalamt: row.dec_totalamt,
          vac_remark: row.vac_remark,
          vac_storename: row.vac_storename,
        },
      ];
      this.removeKeyboardShortCuts();
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            // Edit : Sales Item Entry
            alertMessage={
              <SalesItemEntry
                bint_itemsrno={bint_itemsrno}
                edit_salessrno={edit_salessrno}
                getItemList={this.getItemList}
                refreshSalesItemList={this.refreshSalesItemList}
                resetAmount={this.resetAmount}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                PackingList={this.state.PackingList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                EditSalesItemData={EditSalesItemData}
                dtpDate={this.state.formData.dtpDate}
                dtpDueDate={this.state.formData.dtpDueDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                cmbBillType={this.state.formData.cmbBillType}
                txtBillNo={this.state.formData.LblBillNo}
                bint_billno={this.state.formData.txtBillNo}
                cmbCustomer={this.state.formData.cmbCustomer}
                cmbReference={this.state.formData.cmbReference}
                CustomerStateCode={this.state.CustomerStateCode}
                CustomerData={this.state.CustomerData}
                cmbShipTo={this.state.formData.cmbShipTo}
                txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                cmbTransactionType={this.state.formData.cmbTransactionType}
                txtRemark={this.state.formData.txtRemark}
                rowsPaymentMode={this.state.rowsPaymentMode}
                rowsOtherDetail={this.state.rowsOtherDetail}
                dec_beforetaxamt={this.state.totalBeforeTaxAmt}
                dec_aftertaxamt={this.state.totalAfterTaxAmt}
                chkReceiptGenerated={this.state.formData.chkReceiptGenerated}
              />
            }
            defaultOpenDialog={true}
            handleOnClickNo={this.ShortCut}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete Item : " + vac_itemname + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteSalesItem(
                bint_acyear,
                bint_acid,
                edit_salessrno,
                bint_itemsrno,
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    }
  };

  handleOnNewEntryClick = () => {
    if (this.validateSales() === true) {
      let ARD = null;
      this.setState({ ARD }, () => {
        this.removeKeyboardShortCuts();
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            // New : Sales Item Entry'
            alertMessage={
              <SalesItemEntry
                refreshSalesItemList={this.refreshSalesItemList}
                getItemList={this.getItemList}
                resetAmount={this.resetAmount}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                PackingList={this.state.PackingList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                edit_salessrno={this.state.formData.edit_salessrno}
                dtpDate={this.state.formData.dtpDate}
                dtpDueDate={this.state.formData.dtpDueDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                cmbBillType={this.state.formData.cmbBillType}
                txtBillNo={this.state.formData.LblBillNo}
                bint_billno={this.state.formData.txtBillNo}
                cmbCustomer={this.state.formData.cmbCustomer}
                cmbReference={this.state.formData.cmbReference}
                CustomerStateCode={this.state.CustomerStateCode}
                CustomerData={this.state.CustomerData}
                cmbShipTo={this.state.formData.cmbShipTo}
                txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                cmbTransactionType={this.state.formData.cmbTransactionType}
                txtRemark={this.state.formData.txtRemark}
                rowsPaymentMode={this.state.rowsPaymentMode}
                rowsOtherDetail={this.state.rowsOtherDetail}
                dec_beforetaxamt={this.state.totalBeforeTaxAmt}
                dec_aftertaxamt={this.state.totalAfterTaxAmt}
                // onSuccessfulSalesItemEntry={this.updateStateInfo}
              />
            }
            defaultOpenDialog={true}
            handleOnClickNo={() => {
              this.ShortCut();
            }}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  setEwayBillARDNull = (EWayBillData) => {
    this.setState({ ARD: null, EWayBillData });
  };

  ewaybillprocess = () => {
    if (this.validateSales() === true) {
      let ARD = null;
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            fullscreenOnly={true}
            labelDisagree="Close"
            alertMessage={
              <SalesEWayBill
                setEwayBillARDNull={this.setEwayBillARDNull}
                EWayBillData={this.state.EWayBillData}
                StateList={this.state.StateList}
                resetAmount={this.resetAmount}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                PackingList={this.state.PackingList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                edit_salessrno={this.state.formData.edit_salessrno}
                dtpDate={this.state.formData.dtpDate}
                dtpDueDate={this.state.formData.dtpDueDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                cmbBillType={this.state.formData.cmbBillType}
                txtBillNo={this.state.formData.LblBillNo}
                bint_billno={this.state.formData.txtBillNo}
                cmbCustomer={this.state.formData.cmbCustomer}
                cmbReference={this.state.formData.cmbReference}
                CustomerStateCode={this.state.CustomerStateCode}
                CustomerData={this.state.CustomerData}
                cmbShipTo={this.state.formData.cmbShipTo}
                txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                cmbTransactionType={this.state.formData.cmbTransactionType}
                txtRemark={this.state.formData.txtRemark}
                rowsPaymentMode={this.state.rowsPaymentMode}
                rowsOtherDetail={this.state.rowsOtherDetail}
                dec_beforetaxamt={this.state.totalBeforeTaxAmt}
                dec_aftertaxamt={this.state.totalAfterTaxAmt}
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleOnNewEntryClickOtherDetail = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={<DetailMaster />}
          defaultOpenDialog={true}
          handleOnClickNo={this.getDetailList}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangeRowsPerPagePaymentMode = (rowsPerPagePaymentMode) => {
    this.setState({ rowsPerPagePaymentMode });
  };

  handleOnRowDataChangeOtherDetail = (
    rowsOtherDetail,
    handledRowIndex,
    colID,
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          tblCGST: 0,
          tblSGST: 0,
          tblIGST: 0,
        },
      },
      () => {
        let totalBeforeTaxAmt = 0;
        let totalAfterTaxAmt = 0;
        let tblCGST = 0,
          tblSGST = 0,
          minustblIGST = 0,
          plustblIGST = 0;
        if (isNumeric(this.state.formData.tblCGST)) {
          tblCGST = Number(this.state.formData.tblCGST);
        }
        if (isNumeric(this.state.formData.tblSGST)) {
          tblSGST = Number(this.state.formData.tblSGST);
        }
        if (isNumeric(this.state.formData.tblIGST)) {
          minustblIGST = Number(this.state.formData.tblIGST);
          plustblIGST = Number(this.state.formData.tblIGST);
        }
        rowsOtherDetail.map((row, index) => {
          if (isNumeric(row["vac_value"])) {
            let value = Number(row["vac_value"]);
            if (row["vac_taxname"] && row["vac_calculation"] == "+") {
              totalBeforeTaxAmt += value;
              let result = this.taxCalcualte(
                row,
                "+",
                tblCGST,
                tblSGST,
                plustblIGST,
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              plustblIGST = Number(result.tblIGST);
            } else if (row["vac_taxname"] && row["vac_calculation"] == "-") {
              totalBeforeTaxAmt -= value;
              let result = this.taxCalcualte(
                row,
                "-",
                tblCGST,
                tblSGST,
                minustblIGST,
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              minustblIGST = Number(result.tblIGST);
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "+"
            ) {
              totalAfterTaxAmt += value;
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "-"
            ) {
              totalAfterTaxAmt -= value;
            }
          }
        });

        let tblIGST = Number(plustblIGST) + Number(minustblIGST);

        this.setState(
          {
            rowsOtherDetail,
            rowsCountOtherDetail: rowsOtherDetail.length,
            totalBeforeTaxAmt,
            totalAfterTaxAmt,
            formData: {
              ...this.state.formData,
              tblCGST: Number(tblCGST),
              tblSGST: Number(tblSGST),
              tblIGST: Number(tblIGST),
              txtCGST: 0,
              txtSGST: 0,
              txtIGST: 0,
            },
          },
          () => {
            this.calNetAmount();
          },
        );
      },
    );
  };
  handleTableEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const nextCtrlID = e.target.getAttribute("nextctrlid");

      if (nextCtrlID) {
        const nextCtrl = document.getElementById(nextCtrlID);

        if (nextCtrl) {
          nextCtrl.focus();
        }
      }
    }
  };
  taxCalcualte = (row, icon, tblCGST, tblSGST, tblIGST) => {
    if (isNumeric(row["vac_value"])) {
      let value = Number(row["vac_value"]);
      if (row["vac_taxname"].length > 0) {
        const txtTaxable = value,
          TaxName = getTaxNumFromStr(row["vac_taxname"]);

        if (Number(txtTaxable) != 0 && Number(TaxName) >= 0) {
          tblCGST =
            icon == "+"
              ? tblCGST + (txtTaxable * (TaxName / 2)) / 100
              : tblCGST - (txtTaxable * (TaxName / 2)) / 100;
          tblCGST = Number(tblCGST);
          tblCGST = tblCGST.toFixed(2);
          tblSGST = tblCGST;

          if (
            this.state.CustomerStateCode !=
            localStorage.getItem("CompStateCode")
          ) {
            tblIGST = Number(tblCGST) + Number(tblSGST);
            tblCGST = 0;
            tblSGST = 0;
          }
        }
      }
    }
    return { tblCGST, tblSGST, tblIGST };

    /* this.setState(
      {
        formData: {
          ...this.state.formData,
          tblCGST: Number(tblCGST),
          tblSGST: Number(tblSGST),
          tblIGST: Number(tblIGST),
        },
      },
      () => {
        
      }
    ); */
  };

  // balnkTaxCalculate = (totalBeforeTaxAmt) => {
  //   if (totalBeforeTaxAmt == 0) {
  //     this.setState({
  //       formData: {
  //         ...this.state.formData,
  //         tblCGST: 0,
  //         tblSGST: 0,
  //         tblIGST: 0,
  //       },
  //     });
  //   }
  // };

  handleOnRowDataChangePaymentMode = (
    rowsPaymentMode,
    handledRowIndex,
    colID,
  ) => {
    this.setState({
      rowsPaymentMode,
      rowsCountPaymentMode: rowsPaymentMode.length,
    });
  };

  handleOnChkChange = (e) => {
    if (this.getAdvancePaidAccessStatus()) {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            [e.target.name]: e.target.checked,
          },
        },
        () => {},
      );
    } else {
      this.setState({
        formData: {
          ...this.state.formData,
          [e.target.name]: false,
        },
      });
    }
  };
  //#endregion handle

  //#region function

  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  getEnabledAdvPaymentStatus = () => {
    if (this.state.formData.cmbTransactionType === "Paid") {
      return false;
    } else {
      return true;
    }
  };

  getAdvancePaidAccessStatus = () => {
    return (
      this.state.rowsCount >= 1 && Number(this.state.formData.txtAdvPayment) > 0
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkReceiptGenerated"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts(
        this.saveSales,
        this.clearInfo,
        () => {
          this.deleteSales(this.state.formData.edit_salessrno);
        },
      ),
    });
  };

  validateSales = () => {
    let result = false;
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpDate,
        "dtpDate",
        this.props.toastErrorMsg,
      ) == false
    ) {
      return false;
    } else if (this.state.formData.cmbBillType.length <= 0) {
      this.props.toastErrorMsg("Select Bill Type", "cmbBillType");
    } else if (this.state.formData.txtBillNo.length <= 0) {
      this.props.toastErrorMsg("Enter Bill No", "txtBillNo");
    } else if (this.state.formData.cmbCustomer.length <= 0) {
      this.props.toastErrorMsg("Select Customer Name", "cmbCustomer");
    } else if (
      isValidItem(
        this.state.Customer,
        "vac_customer",
        this.state.formData.cmbCustomer,
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Customer Name", "cmbCustomer");
    } else if (
      this.state.formData.cmbShipTo.length > 0 &&
      isValidItem(
        this.state.ShipTo,
        "vac_customer",
        this.state.formData.cmbShipTo,
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Ship to Name", "cmbShipTo");
    } else if (
      this.state.formData.cmbReference &&
      this.state.formData.cmbReference.length > 0 &&
      isValidItem(
        this.state.ReferenceList,
        "vac_referencename",
        this.state.formData.cmbReference,
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Reference Name", "cmbReference");
    } else if (this.state.formData.cmbTransactionType.length <= 0) {
      this.props.toastErrorMsg("Select Transaction Type", "cmbTransactionType");
    } else {
      result = true;
    }
    return result;
  };

  validateSalesItemCount = () => {
    // this.props.toastErrorMsg("validateSalesItemCount")
    let result = false;
    if (this.state.rowsCount <= 0) {
      this.props.toastErrorMsg("Enter atleast one item", "dtpDate");
    } else {
      result = true;
    }
    return result;
  };

  validatePaymentModeAmount = () => {
    let result = false,
      dec_amount = 0;
    if (
      this.getPaymentModeDataStatus &&
      this.state.rowsPaymentMode.length > 0
    ) {
      this.state.rowsPaymentMode.map((row) => {
        if (row.dec_amount != undefined) {
          dec_amount += Number(row.dec_amount);
        }
      });
      if (this.state.formData.cmbTransactionType === "Paid") {
        if (dec_amount == Number(this.state.formData.txtNetPayment)) {
          result = true;
        } else {
          this.props.toastErrorMsg(
            "Net Payment Amount and Payment Mode Ledger Amount must be same",
            "txtNetPayment",
          );
        }
      } else if (this.state.formData.cmbTransactionType === "Remain") {
        if (dec_amount == Number(this.state.formData.txtAdvPayment)) {
          result = true;
        } else {
          this.props.toastErrorMsg(
            "Advance Amount and Payment Mode Ledger Amount must be same",
            "txtNetPayment",
          );
        }
      }
    } else {
      result = true;
    }
    return result;
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus, autoResetFormData: false }, () => {
      let bint_acyear = 0,
        bint_acid = "",
        edit_salessrno = 0;
      if (this.props.location.state && this.props.location.state != null) {
        bint_acid = this.props.location.state.bint_acid;
        edit_salessrno = this.props.location.state.bint_salessrno;
        bint_acyear = this.props.location.state.bint_acyear;
        let reqData = {
          Op: "SalesData",
          bint_acyear,
          bint_acid,
          edit_salessrno,
          vac_userid: localStorage.getItem("logInID"),
          bint_ci: localStorage.getItem("CI"),
        };
        fetchSales(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            let CompanyList = res.data.CompanyList,
              Customer = res.data.CustomerList,
              ShipTo = res.data.CustomerList,
              TaxNameList = res.data.TaxList,
              ItemNameList = res.data.ItemList,
              StoreList = res.data.StoreList,
              SalesInvoiceGeneration = "",
              InvoiceNoList = res.data.InvoiceNoList,
              DefaultEntrySettingList = res.data.DefaultEntrySettingList,
              rowsOtherDetail = [],
              rowsCountOtherDetail = rowsOtherDetail.length,
              rows = [],
              rowsCount = rows.length,
              rowsPaymentMode = [],
              rowsCountPaymentMode = rowsPaymentMode.length,
              LedgerNameList = [],
              DetailList = [],
              ReferenceList = res.data.ReferenceList,
              PaymentData = [],
              EWayBillData = [],
              StateList = [];

            res.data.GeneralSettingList.map((row) => {
              if (row.vac_module === "Sales") {
                if (row.vac_key === "Sales Invoice Generation") {
                  SalesInvoiceGeneration = row.vac_value;
                }
              }
            });

            if (res.data.SalesItemData && res.data.SalesItemData.length > 0) {
              rows = this.addActionColStatus(res.data.SalesItemData);
              rowsCount = rows.length;
            }
            if (res.data.EWayBillData) {
              EWayBillData = res.data.EWayBillData;
            }
            if (res.data.StateList) {
              StateList = res.data.StateList;
            }
            if (res.data.LedgerNameList && res.data.LedgerNameList.length > 0) {
              rowsPaymentMode = res.data.LedgerNameList;
              LedgerNameList = res.data.LedgerNameList;
              rowsCountPaymentMode = rowsPaymentMode.length;
            } /*  else {
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = res.data.LedgerNameList;
                LedgerNameList = res.data.LedgerNameList;
              }
            } */
            /* if (res.data.PaymentData && res.data.PaymentData.length > 0) {
              res.data.PaymentData.map((odd) => {
                let isFound = 0;
                rowsPaymentMode.map((rod) => {
                  if (rod.vac_ledgername === odd.vac_ledgername) {
                    // rod.vac_value = odd.vac_value;
                    rod.dec_amount = odd.dec_amount;
                    rod.vac_chequeno = odd.vac_chequeno;
                    rod.vac_referenceno = odd.vac_referenceno;
                    rod.dat_transactiondate = odd.dat_transactiondate;
                    rod.vac_remark = odd.vac_remark;
                    rod.vac_groupname = odd.vac_groupname;
                    isFound++;
                  }
                });
                if (isFound === 0) {
                  rowsPaymentMode.push({
                    vac_ledgername: odd.vac_ledgername,
                    dec_amount: odd.dec_amount,
                    vac_chequeno: odd.vac_chequeno,
                    vac_referenceno: odd.vac_referenceno,
                    dat_transactiondate: odd.dat_transactiondate,
                    vac_remark: odd.vac_remark,
                    vac_groupname: odd.vac_groupname,
                    // bint_displayorderno: rowsPaymentMode.length + 1,
                  });
                }
              });
              rowsCountPaymentMode = rowsPaymentMode.length;
            } */
            if (res.data.DetailList && res.data.DetailList.length > 0) {
              rowsOtherDetail = res.data.DetailList.map((row) => {
                return {
                  ...row,
                  txtFormate:
                    row["vac_calculationstyle"] == "Before Tax"
                      ? row["vac_calculation"] +
                        (row["vac_taxname"]
                          ? "(" + row["vac_taxname"] + ")"
                          : "")
                      : row["vac_calculation"],
                };
              });
              DetailList = res.data.DetailList;
              rowsCountOtherDetail = rowsOtherDetail.length;
            }
            if (
              res.data.OtherDetailData &&
              res.data.OtherDetailData.length > 0
            ) {
              res.data.OtherDetailData.map((odd) => {
                let isFound = 0;
                rowsOtherDetail.map((rod) => {
                  if (rod.vac_headingvalue === odd.vac_headingvalue) {
                    rod.vac_value = odd.vac_value;
                    isFound++;
                  }
                });
                if (isFound === 0) {
                  rowsOtherDetail.push({
                    vac_headingvalue: odd.vac_headingvalue,
                    vac_value: odd.vac_value,
                    bint_displayorderno: rowsOtherDetail.length + 1,
                  });
                }
              });
              rowsCountOtherDetail = rowsOtherDetail.length;
            }

            if (res.data.PaymentData && res.data.PaymentData.length > 0) {
              PaymentData = res.data.PaymentData;
            }
            if (res.data.OrderSelection === "true") {
              this.setState({ Displaybtn: true });
            }

            let subSupplyType = InvoiceNoList.find(
              (row) =>
                row.vac_invoicetype === res.data.SalesList[0].vac_billtype,
            )?.vac_ewaybillsubtype;

            this.setState(
              {
                dataLoadStatus: true,
                Customer,
                CompanyList,
                ShipTo,
                TaxNameList,
                ItemNameList,
                BillNoList: InvoiceNoList,
                DefaultEntrySettingList,
                StoreList,
                SalesInvoiceGeneration,
                rows,
                rowsCount,
                rowsOtherDetail,
                rowsCountOtherDetail,
                rowsPaymentMode,
                rowsCountPaymentMode,
                LedgerNameList,
                DetailList,
                ReferenceList,
                PaymentData,
                totalAfterTaxAmt: res.data.SalesList[0].dec_aftertaxamt,
                totalBeforeTaxAmt: res.data.SalesList[0].dec_beforetaxamt,
                EWayBillData,
                StateList,
                formData: {
                  ...this.state.formData,
                  edit_salessrno: res.data.SalesList[0].bint_salessrno,
                  dtpDate: res.data.SalesList[0].dat_salesdate,
                  subSupplyType,
                  // dtpDueDate: res.data.SalesList[0].dtpDueDate,
                  cmbCompany: res.data.SalesList[0].vac_company,
                  cmbBillType: res.data.SalesList[0].vac_billtype,
                  txtBillNo: res.data.SalesList[0].bint_billno,
                  LblBillNo: res.data.SalesList[0].vac_billno,
                  cmbCustomer: res.data.SalesList[0].vac_customer,
                  cmbShipTo: getString_or_Blank4Null(
                    res.data.SalesList[0].vac_customershipto,
                  ),
                  txtDiscount: res.data.SalesList[0].dec_discamt,
                  txtTaxable: res.data.SalesList[0].dec_taxable,
                  txtCGST: res.data.SalesList[0].dec_cgst,
                  txtSGST: res.data.SalesList[0].dec_sgst,
                  txtIGST: res.data.SalesList[0].dec_igst,
                  txtGrandTotal: res.data.SalesList[0].dec_grtotal,
                  txtTDSAmount: res.data.SalesList[0].dec_tdsamount,
                  txtAdvPayment: res.data.SalesList[0].dec_advancepayment,
                  txtRoundOff: res.data.SalesList[0].dec_roundoff,
                  txtNetPayment: res.data.SalesList[0].dec_netpayment,
                  dec_remainamt: res.data.SalesList[0].dec_remainamt,
                  cmbTransactionType:
                    res.data.SalesList[0].vac_salestransactiontype,
                  txtRemark: res.data.SalesList[0].vac_remark,
                  cmbReference: res.data.SalesList[0].vac_referencename
                    ? res.data.SalesList[0].vac_referencename
                    : "",
                  chkReceiptGenerated:
                    res.data.SalesList[0].vac_receiptgenerated == "Yes"
                      ? true
                      : false,
                  txtACKDate: res.data.SalesList[0].dat_ackdate,
                  txtACKno: res.data.SalesList[0].vac_ackno,
                  txtIRN: res.data.SalesList[0].vac_irn,
                },
              },
              () => {
                this.getStateCodeOFCustomer();
              },
            );
          })
          .catch((error) => {
            this.props.toastMsg(
              "error",
              "Unkonwn Error occured in onFormLoad. " + error,
            );
          });
      } else {
        const reqData = {
          Op: "LoadSalesAllCmbDetail",
          bint_acid: localStorage.getItem("acid"),
          bint_acyear: localStorage.getItem("ACY"),
          vac_userid: localStorage.getItem("logInID"),
        };
        fetchSales(reqData)
          .then((res) => {
            dataLoadStatus = true;
            let CompanyList = [],
              Customer = [],
              ShipTo = [],
              TaxNameList = [],
              ItemNameList = [],
              StoreList = [],
              SalesInvoiceGeneration = [],
              InvoiceNoList = [],
              DefaultEntrySettingList = [],
              cmbTransactionType = "",
              rowsOtherDetail = [],
              rowsCountOtherDetail = rowsOtherDetail.length,
              rowsPaymentMode = [],
              rowsCountPaymentMode = rowsPaymentMode.length,
              LedgerNameList = [],
              DetailList = [],
              PaymentData = [],
              ReferenceList = [];
            if (res.data.CustomerList && res.data.CustomerList.length > 0) {
              Customer = res.data.CustomerList;
            }
            if (res.data.CompanyList && res.data.CompanyList.length > 0) {
              CompanyList = res.data.CompanyList;
            }
            if (res.data.CustomerList && res.data.CustomerList.length > 0) {
              ShipTo = res.data.CustomerList;
            }
            if (res.data.TaxList && res.data.TaxList.length > 0) {
              TaxNameList = res.data.TaxList;
            }
            if (res.data.ItemList && res.data.ItemList.length > 0) {
              ItemNameList = res.data.ItemList;
            }
            if (res.data.StoreList && res.data.StoreList.length > 0) {
              StoreList = res.data.StoreList;
            }
            if (
              res.data.GeneralSettingList &&
              res.data.GeneralSettingList.length > 0
            ) {
              // SalesInvoiceGeneration = res.data.GeneralSettingList[0].vac_value;
              res.data.GeneralSettingList.map((row) => {
                if (row.vac_module === "Sales") {
                  if (row.vac_key === "Sales Invoice Generation") {
                    SalesInvoiceGeneration = row.vac_value;
                  }
                }
              });
            }
            if (res.data.InvoiceNoList && res.data.InvoiceNoList.length > 0) {
              InvoiceNoList = res.data.InvoiceNoList;
            }
            if (
              res.data.DefaultEntrySettingList &&
              res.data.DefaultEntrySettingList.length > 0
            ) {
              DefaultEntrySettingList = res.data.DefaultEntrySettingList;
            }
            if (DefaultEntrySettingList.length > 0) {
              cmbTransactionType =
                DefaultEntrySettingList[0].vac_transacationtype;
            }
            if (res.data.LedgerNameList && res.data.LedgerNameList.length > 0) {
              rowsPaymentMode = res.data.LedgerNameList;
              LedgerNameList = res.data.LedgerNameList;
              rowsCountPaymentMode = rowsPaymentMode.length;
            }
            if (res.data.DetailList && res.data.DetailList.length > 0) {
              rowsOtherDetail = res.data.DetailList.map((row) => {
                return {
                  ...row,
                  txtFormate:
                    row["vac_calculationstyle"] == "Before Tax"
                      ? row["vac_calculation"] +
                        (row["vac_taxname"]
                          ? "(" + row["vac_taxname"] + ")"
                          : "")
                      : row["vac_calculation"],
                };
              });
              DetailList = res.data.DetailList;
              rowsCountOtherDetail = rowsOtherDetail.length;
            }
            if (res.data.ReferenceList && res.data.ReferenceList.length > 0) {
              ReferenceList = res.data.ReferenceList;
            }
            if (res.data.PaymentData && res.data.PaymentData.length > 0) {
              PaymentData = res.data.PaymentData;
            }
            if (res.data.OrderSelection === "true") {
              this.setState({ Displaybtn: true });
            }
            this.setState(
              {
                dataLoadStatus,
                Customer,
                CompanyList,
                ShipTo,
                TaxNameList,
                ItemNameList,
                StoreList,
                SalesInvoiceGeneration,
                BillNoList: InvoiceNoList,
                DefaultEntrySettingList,
                LedgerNameList,
                DetailList,
                PaymentData,
                formData: {
                  ...this.state.formData,
                  cmbTransactionType,
                },
                autoResetFormData: true,
                rowsOtherDetail,
                rowsCountOtherDetail: rowsOtherDetail.length,
                rowsPaymentMode,
                rowsCountPaymentMode,
                ReferenceList,
              },
              () => {
                this.getDefaultBillType();
              },
            );
          })
          .catch((error) => {
            console.log("Unknown error occurred in onFormLoad.", error);
          });
      }
    });
    document.getElementById("cmbCustomer").focus();
  };

  clearInfo = () => {
    let cmbTransactionType = "";
    if (
      this.state.DefaultEntrySettingList &&
      this.state.DefaultEntrySettingList.length > 0
    ) {
      cmbTransactionType =
        this.state.DefaultEntrySettingList[0].vac_transacationtype;
    }
    this.setState(
      {
        totalAfterTaxAmt: "",
        totalBeforeTaxAmt: "",
        formData: {
          ...this.state.formData,
          edit_salessrno: "",
          dtpDate: get_YMD_from_SYS(new Date()),
          dtpDueDate: "",
          cmbCompany: localStorage.getItem("CompanyName"),
          // cmbBillType: "",
          // txtBillNo: "",
          // LblBillNo: "",
          cmbCustomer: "",
          cmbShipTo: "",
          txtOtherDetail: "",
          txtDiscount: "",
          txtTaxable: "",
          txtCGST: "",
          txtSGST: "",
          txtIGST: "",
          tblCGST: "",
          tblSGST: "",
          tblIGST: "",
          txtGrandTotal: "",
          txtTDSAmount: "",
          txtAdvPayment: "",
          txtNetPayment: "",
          txtRoundOff: "",
          cmbTransactionType,
          txtRemark: "",
          chkReceiptGenerated: false,
          cmbReference: "",
          txtACKDate: "",
          txtACKno: "",
          txtIRN: "",
        },
        rows: [],
        rowsCount: 0,
        rowsOtherDetail: this.state.rowsOtherDetail,
        rowsCountOtherDetail: this.state.rowsOtherDetail.length,
        rowsPaymentMode: copyRowsAllCols(
          this.state.LedgerNameList,
          this.state.PaymentmodeListCols,
        ),
        rowsCountPaymentMode: this.state.LedgerNameList.length,
        PaymentData: [],
      },
      () => {
        this.getDefaultBillType();
        document.getElementById("dtpDate").focus();
        this.props.navigateTo("SalesEntry");
      },
    );
  };

  updateStateInfo = (rows) => {
    let count = 0;
    rows.map((row) => {
      if (count === 0) {
        count++;
        this.setState({
          ARD: null,
          rows,
          rowsCount: rows.length,
          OrderselectionVisible: true,
        });
      }
    });
  };

  addActionColStatus = (rows) => {
    // console.log("rows disable edit", rows);
    const newRows = rows.map((row) => {
      const actionStatus = row.vac_orderitemno.length > 0 ? true : false;
      // console.log("row.vac_orderitemno", row.vac_orderitemno);
      return {
        ...row,
        DisableEdit: actionStatus,
      };
    });
    return newRows;
  };

  // DisableOnEditDelete = (vac_orderitemno) => {
  //   let DisableEdit = false;
  //   if (vac_orderitemno.length == 0) {
  //     DisableEdit = false;
  //   } else {
  //     DisableEdit = true;
  //   }
  //   return DisableEdit;
  // };

  OrderSelection = () => {
    if (this.validateSales() === true) {
      // this.getLedgerName = () => {
      //   if (this.state.LedgerNameList && this.state.LedgerNameList[0]) {
      //     return this.state.LedgerNameList[0].vac_ledgername;
      //   } else {
      //     return "";
      //   }
      // };
      let ARD = null;
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            maxWidthClass={"1000px"}
            // alertTitle={'Sales Item Entry'}
            alertMessage={
              <OrderSelection
                SelectionFrom="Sales"
                Customer={this.state.formData.cmbCustomer}
                DRPname={
                  this.state.LedgerNameList && this.state.LedgerNameList[0]
                    ? this.state.LedgerNameList[0].vac_ledgername
                    : ""
                }
                bint_acyear={localStorage.getItem("ACY")}
                bint_acid={localStorage.getItem("acid")}
                cmbCompany={localStorage.getItem("CompanyName")}
                bint_salessrno={this.state.formData.edit_salessrno}
                dtpDate={this.state.formData.dtpDate}
                cmbBillType={this.state.formData.cmbBillType}
                txtBillNo={this.state.formData.LblBillNo}
                bint_billno={this.state.formData.txtBillNo}
                cmbCustomer={this.state.formData.cmbCustomer}
                cmbShipTo={this.state.formData.cmbShipTo}
                cmbReference={this.state.formData.cmbReference}
                // CustomerStateCode={this.state.CustomerStateCode}
                // txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                txtNetPayment={this.state.formData.txtNetPayment}
                cmbTransactionType={this.state.formData.cmbTransactionType}
                txtRemark={this.state.formData.txtRemark}
                vac_receiptgenerated={
                  this.state.formData.chkReceiptGenerated ? "Yes" : "No"
                }
                vac_referencename={this.state.formData.cmbReference}
                bint_ci={localStorage.getItem("CI")}
                vac_username={localStorage.getItem("UserName")}
                onSuccessfulSelsSelection={this.updateStateInfo}
                refreshSalesItemList={this.refreshSalesItemList}
                resetAmount={this.resetAmount}
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  saveSales = (
    bolinvoiceprint,
    copyInvoiceDetailsToClipBoard,
    bolewaybillprocess,
  ) => {
    if (
      this.validateSales() &&
      this.validateSalesItemCount() &&
      this.validatePaymentModeAmount()
    ) {
      // this.props.toastErrorMsg("Second Alert")
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      // this.props.toastErrorMsg("Third Alert");
      // console.log(
      //   "Number(this.state.formData.tblCGST)",
      //   Number(this.state.formData.tblCGST)
      // );
      // console.log(
      //   "this.state.formData.txtCGST + this.state.formData.tblCGST",
      //   Number(this.state.formData.txtCGST) +
      //     Number(this.state.formData.tblCGST)
      // );
      let rowsTotal = getRowColSum(this.state.rows, [
        "dec_cgstamt",
        "dec_sgstamt",
        "dec_igstamt",
      ]);
      /* dec_cgst:
            Number(this.state.formData.txtCGST) +
            Number(this.state.formData.tblCGST),
          dec_sgst:
            Number(this.state.formData.txtSGST) +
            Number(this.state.formData.tblSGST),
          dec_igst:
            Number(this.state.formData.txtIGST) +
            Number(this.state.formData.tblIGST), */
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveSales_Item",
          bint_acyear: localStorage.getItem("ACY"),
          bolinvoiceprint: false,
          bint_acid: localStorage.getItem("acid"),
          vac_company: this.state.formData.cmbCompany,
          bint_salessrno: this.state.formData.edit_salessrno,
          dat_salesdate: this.state.formData.dtpDate,
          vac_billtype: this.state.formData.cmbBillType,
          vac_billno: this.state.formData.LblBillNo,
          bint_billno: this.state.formData.txtBillNo,
          vac_customer: this.state.formData.cmbCustomer,
          vac_customershipto: this.state.formData.cmbShipTo,
          dec_discamt: this.state.formData.txtDiscount,
          dec_taxable: this.state.formData.txtTaxable,
          dec_cgst:
            Number(rowsTotal.dec_cgstamt) + Number(this.state.formData.tblCGST),
          dec_sgst:
            Number(rowsTotal.dec_sgstamt) + Number(this.state.formData.tblSGST),
          dec_igst:
            Number(rowsTotal.dec_igstamt) + Number(this.state.formData.tblIGST),
          dec_grtotal: this.state.formData.txtGrandTotal,
          dec_tdsamount: this.state.formData.txtTDSAmount,
          dec_advancepayment: this.state.formData.txtAdvPayment,
          dec_roundoff: this.state.formData.txtRoundOff,
          dec_netpayment: this.state.formData.txtNetPayment,
          vac_salestransactiontype: this.state.formData.cmbTransactionType,
          bint_vouno: 0,
          vac_remark: this.state.formData.txtRemark,
          vac_receiptgenerated: this.state.formData.chkReceiptGenerated
            ? "Yes"
            : "No",
          PaymentData: this.getPaymentModeDataStatus()
            ? this.state.rowsPaymentMode
            : [],
          OtherDetailData: this.state.rowsOtherDetail,
          bint_ci: localStorage.getItem("CI"),
          vac_username: localStorage.getItem("UserName"),
          vac_referencename: this.state.formData.cmbReference,
          dec_beforetaxamt: this.state.totalBeforeTaxAmt,
          dec_aftertaxamt: this.state.totalAfterTaxAmt,
        };
        fetchSales(reqData)
          .then((res) => {
            // console.log("reqData", reqData);
            this.props.updateProcessing(res.data.msgType, res.data.message);
            // console.log("res.data.msgType", res.data.msgType);
            if (res.data.msgType === "success") {
              let DefaultEntrySettingList = res.data.DefaultEntrySettingList,
                cmbTransactionType = "",
                rowsOtherDetail = [],
                rowsCountOtherDetail = rowsOtherDetail.length,
                rowsPaymentMode = [],
                rowsCountPaymentMode = rowsPaymentMode.length,
                InvoiceNoList = res.data.InvoiceNoList;
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = res.data.LedgerNameList;
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                rowsOtherDetail = res.data.DetailList;
                rowsCountOtherDetail = rowsOtherDetail.length;
              }
              if (DefaultEntrySettingList.length > 0) {
                cmbTransactionType =
                  DefaultEntrySettingList[0].vac_transacationtype;
              }
              this.setState(
                {
                  dataLoadStatus: true,
                  BillNoList: InvoiceNoList,
                  DefaultEntrySettingList,
                  formData: {
                    ...this.state.formData,
                    cmbTransactionType,
                  },
                  rowsOtherDetail,
                  rowsCountOtherDetail,
                  rowsPaymentMode,
                  rowsCountPaymentMode,
                },
                () => {
                  if (bolinvoiceprint) {
                    this.openInvoiceARDSelection();
                  }
                  /** Call copyInvoiceDetailsToClipBoard */
                  if (copyInvoiceDetailsToClipBoard) {
                    copyInvoiceDetailsToClipBoard();
                  }
                  if (bolewaybillprocess) {
                    this.ewaybillprocess();
                  }
                  this.clearInfo();
                },
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in saveSales.", error);
          });
      });
    }
  };

  onDeleteBtnClick = () => {
    if (this.state.formData.edit_salessrno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Bill No. : " +
              this.state.formData.LblBillNo +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteSales(this.state.formData.edit_salessrno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("There are no sales to delete", "dtpDate");
    }
  };

  deleteSales = (edit_salessrno) => {
    if (edit_salessrno > 0) {
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "DeleteSales",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          edit_salessrno: edit_salessrno,
          dat_fromdate: "",
          dat_todate: "",
        };
        fetchSales(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.setState({ ARD: null, dataLoadStatus: true }, () => {
                this.clearInfo();
              });
            } else {
              this.setState({ dataLoadStatus: true });
            }
          })
          .catch((error) => {
            this.props.updateProcessing(
              "error",
              "Unknown error occurred in delete deleteSales. " + error,
            );
          });
      });
    } else {
      this.props.notifyProcessing();
      this.props.updateProcessing(
        "error",
        "There are no sales records to delete.",
      );
    }
  };

  deleteSalesItem = (bint_acyear, bint_acid, bint_salessrno, bint_itemsrno) => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteSalesItem",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_salessrno: bint_salessrno,
        edit_itemsrno: bint_itemsrno,
        dec_tdsamount: this.state.formData.txtTDSAmount,
        dec_advancepayment: this.state.formData.txtAdvPayment,
        vac_customer: this.state.formData.cmbCustomer,
        bint_ci: localStorage.getItem("CI"),
        vac_username: localStorage.getItem("UserName"),
        dat_salesdate: this.state.formData.dtpDate,
        vac_remark: this.state.formData.txtRemark,
        vac_salestransactiontype: this.state.formData.cmbTransactionType,
        PaymentData: this.state.rowsPaymentMode,
        dec_roundoff: this.state.formData.txtRoundOff,
        vac_billno: this.state.formData.txtBillNo,
        dec_netpayment: this.state.formData.txtNetPayment,
        vac_receiptgenerated: this.state.formData.chkReceiptGenerated
          ? "Yes"
          : "No",
      };
      fetchSales(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          let dec_basicamt = 0,
            dec_disamt = 0,
            dec_taxable = 0,
            dec_cgstamt = 0,
            dec_sgstamt = 0,
            dec_igstamt = 0,
            dec_totalamt = 0,
            SalesItemData = [];
          if (res.data.SalesItemData && res.data.SalesItemData.length > 0) {
            rows = this.addActionColStatus(res.data.SalesItemData);
            rowsCount = rows.length;
          }
          if (res.data.TotalItemAmountData) {
            dec_basicamt = Number(res.data.TotalItemAmountData[0].dec_basicamt);
            dec_disamt = Number(res.data.TotalItemAmountData[0].dec_disamt);
            dec_taxable = Number(res.data.TotalItemAmountData[0].dec_taxable);
            dec_cgstamt = Number(res.data.TotalItemAmountData[0].dec_cgstamt);
            dec_sgstamt = Number(res.data.TotalItemAmountData[0].dec_sgstamt);
            dec_igstamt = Number(res.data.TotalItemAmountData[0].dec_igstamt);
            dec_totalamt = Number(res.data.TotalItemAmountData[0].dec_totalamt);
          }
          this.resetAmount(
            dec_taxable,
            dec_cgstamt,
            dec_sgstamt,
            dec_igstamt,
            dec_totalamt,
            dec_disamt,
            bint_salessrno,
          );
          this.setState({
            ARD: null,
            rows,
            rowsCount,
            dataLoadStatus,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in deleteSalesList.", error);
        });
    });
    return true;
  };

  refreshSalesItemList = (rows, rowsCount) => {
    rows = this.addActionColStatus(rows);
    // console.log("rows", rows);
    this.setState(
      {
        rows,
        rowsCount,
      },
      () => {},
    );
  };

  resetAmount = (
    txtTaxable,
    txtCGST,
    txtSGST,
    txtIGST,
    txtGrandTotal,
    txtDiscount,
    edit_salessrno,
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtTaxable,
          txtCGST,
          txtSGST,
          txtIGST,
          txtGrandTotal,
          txtDiscount,
          edit_salessrno,
        },
      },
      () => {
        // console.log("edit_salessrno", edit_salessrno);
        this.calNetAmount();
      },
    );
  };

  calNetAmount = () => {
    let txtNetPayment =
        Number(this.state.formData.txtGrandTotal) -
        Number(this.state.formData.txtTDSAmount) -
        Number(this.state.formData.txtAdvPayment) +
        Number(this.state.formData.txtRoundOff),
      txtRoundOff = 0;

    let arrNetPayment = getRoundOff(txtNetPayment);
    txtNetPayment = arrNetPayment["roff_number"];
    txtRoundOff = arrNetPayment["roff"];
    // console.log("txtNetPayment", txtNetPayment);
    let chkReceiptGenerated = this.state.formData.chkReceiptGenerated;
    if (Number(this.state.formData.txtAdvPayment) === Number(0)) {
      chkReceiptGenerated = false;
    }
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtNetPayment,
          txtRoundOff,
          chkReceiptGenerated,
        },
      },
      () => {},
    );
  };

  generateBillNo = () => {
    if (
      Number(this.state.formData.txtBillNo) > 0 &&
      this.state.formData.SalesInvoiceGeneration != "Auto"
    ) {
      this.props.notifyProcessing();
      const reqData = {
        Op: "CreateStrBillNoFromType",
        bint_acyear: localStorage.getItem("ACY"),
        bint_acid: localStorage.getItem("acid"),
        int_invoiceno: Number(this.state.formData.txtBillNo),
        vac_billtype: this.state.formData.cmbBillType,
      };
      fetchSales(reqData)
        .then((res) => {
          this.props.updateProcessing("success", "Bill No generated");
          this.setState({
            formData: {
              ...this.state.formData,
              LblBillNo: res.data.InvoiceNo,
            },
          });
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in generateBillNo. " + error,
          );
        });
    } else {
      this.props.toastErrorMsg("Enter Bill No", "txtBillNo");
    }
  };

  getBillNo = () => {
    if (this.state.formData.cmbBillType.length > 0) {
      // console.log("this.state.BillNoList", this.state.BillNoList);
      this.state.BillNoList.map((row) => {
        if (row.vac_invoicetype === this.state.formData.cmbBillType) {
          // console.log("row.vac_invoicetype", row.vac_invoicetype);
          // console.log("row.int_invoiceno", row.int_invoiceno);
          // console.log("row.vac_invoiceno", row.vac_invoiceno);
          this.setState(
            {
              formData: {
                ...this.state.formData,
                txtBillNo: row.int_invoiceno,
                LblBillNo: row.vac_invoiceno,
                subSupplyType: row.vac_ewaybillsubtype,
              },
            },
            () => {
              // console.log("this.state.formData.txtBillNo", this.state.formData.txtBillNo);
              // console.log("this.state.formData.LblBillNo", this.state.formData.LblBillNo);
            },
          );
        }
      });
    }
  };

  getStateCodeOFCustomer = () => {
    if (
      this.state.formData.cmbCustomer.length > 0 &&
      this.state.autoResetFormData === true
    ) {
      this.state.Customer.map((row) => {
        if (row.vac_customer === this.state.formData.cmbCustomer) {
          this.setState({
            formData: {
              ...this.state.formData,
              cmbReference:
                row.vac_referencename != null ? row.vac_referencename : "",
            },
            CustomerStateCode: row.vac_statecode,
            CustomerData: row,
          });
        }
      });
    } else if (this.state.autoResetFormData === false) {
      this.setState({ autoResetFormData: true });
    }
  };

  getDefaultBillType = () => {
    if (this.state.BillNoList && this.state.BillNoList.length > 0) {
      this.state.BillNoList.map((row) => {
        if (row.int_default === 1 || row.int_default === "1") {
          this.setState(
            {
              formData: {
                ...this.state.formData,
                cmbBillType: row.vac_invoicetype,
              },
            },
            () => {
              this.getBillNo();
            },
          );
        }
      });
    }
  };

  getCustomerList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadCustomerDetails",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchCustomerMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Customer List Loaded");
        let Customer = res.data.CustomerList,
          ShipTo = res.data.CustomerList;
        this.setState(
          {
            Customer,
            ShipTo,
          },
          () => {
            // console.log("this.state", this.state);
          },
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getCustomerList.", error);
      });
  };

  getReferenceList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadReference",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchReferenceMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Customer List Loaded");
        let ReferenceList = res.data.ReferenceList;
        this.setState(
          {
            ReferenceList,
          },
          () => {
            // console.log("this.state", this.state);
          },
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getCustomerList.", error);
      });
  };

  getDetailList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DetailList",
      bint_acid: localStorage.getItem("acid"),
      vac_detailtype: "",
    };
    fetchDetailMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Detial List Loaded");
        let rowsOtherDetail = res.data.DetailList,
          rowsCountOtherDetail = 0;
        this.setState(
          {
            rowsOtherDetail,
            rowsCountOtherDetail,
          },
          () => {
            // console.log("this.state", this.state);
          },
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getDetailList.", error);
      });
  };

  onAddClickCustomer = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<CustomerMaster />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getCustomerList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  onAddClickReference = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<ReferenceMaster />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getReferenceList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  openInvoiceARDSelection = () => {
    let vac_billno = Array(this.state.formData.LblBillNo);
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<SalesInvoiceSelection
            bint_acid={localStorage.getItem("acid")}
            bint_acyear={localStorage.getItem("ACY")}
            vac_billno={vac_billno}
          />
          defaultOpenDialog={true}
        />
      );
      this.setState({ ARD });
    });
  };

  getItemList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ItemList",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchItemMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Item List Loaded");
        let ItemNameList = res.data.ItemList;
        this.setState(
          {
            ItemNameList,
          },
          () => {
            // console.log("this.state", this.state);
          },
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getItemList.", error);
      });
  };

  getPayRemarkLblVisibleStatus = () => {
    return this.state.formData.cmbTransactionType == "Remain" &&
      Number(this.state.formData.txtAdvPayment) > 0 &&
      this.state.formData.chkReceiptGenerated === false
      ? true
      : false;
  };

  getPaymentModeDataStatus = () => {
    let result = false;
    if (
      this.state.formData.cmbTransactionType == "Paid" ||
      this.getPayRemarkLblVisibleStatus()
    ) {
      result = true;
    } else {
      this.state.rowsPaymentMode.map((row) => {
        // row.vac_ledgername = ''
        row.dec_amount = "";
        row.vac_chequeno = "";
        row.vac_referenceno = "";
        row.dat_transactiondate = "";
        row.vac_remark = "";
      });
    }
    return result;
    /* return this.state.formData.cmbTransactionType == "Paid" ||
      this.getPayRemarkLblVisibleStatus()
      ? true
      : false; */
  };

  setSaveBtnDisplay = () => {
    let isParamFound =
      this.props.params &&
      this.props.params.EditSalesSrNo &&
      this.props.params.EditSalesSrNo.substring(1).length > 0;
    if (isParamFound !== true) {
      isParamFound = false;
    }
    let paramEditSalesSrNo = 0;
    if (isParamFound) {
      var editInfo = this.props.params.EditSalesSrNo.split(":");
      paramEditSalesSrNo = Number(editInfo[2]);
      if (paramEditSalesSrNo <= 0) {
        isParamFound = false;
      }
    }
    // console.log("this.props.userPrivilege.Sales", this.props.userPrivilege.Sales, this.props.userPrivilege.Sales == 'W');
    // console.log("Number(this.state.formData.edit_salessrno)", Number(this.state.formData.edit_salessrno), Number(this.state.formData.edit_salessrno) <= Number(0));
    // console.log("isParamFound", isParamFound, isParamFound === false);
    if (this.props.userPrivilege.Sales == "M") {
      return "block";
    } else if (this.props.userPrivilege.Sales == "R") {
      return "none";
    } else if (
      (this.props.userPrivilege.Sales == "W" &&
        Number(this.state.formData.edit_salessrno) > Number(0) &&
        isParamFound === false) ||
      (this.props.userPrivilege.Sales == "W" &&
        Number(this.state.formData.edit_salessrno) > Number(0) &&
        isParamFound === true &&
        Number(this.state.formData.edit_salessrno) !==
          Number(paramEditSalesSrNo)) ||
      (this.props.userPrivilege.Sales == "W" &&
        Number(this.state.formData.edit_salessrno) <= Number(0))
    ) {
      return "block";
    } else {
      return "none";
    }
  };

  setPaymentData = (rowsPaymentMode) => {
    this.setState(
      {
        rowsPaymentMode,
      },
      () => {
        // console.log("this.state.rows", this.state.rows);
      },
    );
  };

  getDefaultEntrySettingRow = () => {
    let DefaultEntrySettingList = [];
    if (
      this.state.DefaultEntrySettingList &&
      this.state.DefaultEntrySettingList.length > 0
    ) {
      if (
        this.state.DefaultEntrySettingList[0].vac_transacationtype == "Paid"
      ) {
        DefaultEntrySettingList = this.state.DefaultEntrySettingList[0];
      } else {
        if (
          this.state.DefaultEntrySettingList[1].vac_transacationtype == "Paid"
        ) {
          DefaultEntrySettingList = this.state.DefaultEntrySettingList[1];
        }
      }
    }
    return DefaultEntrySettingList;
  };

  handleInvoice = () => {
    // const salesInfo = {
    //   bint_acid: localStorage.getItem("acid"),
    //   bint_acyear: localStorage.getItem("ACY"),
    //   vac_billno: this.state.formData.LblBillNo,
    //   edit_salessrno: this.state.formData.edit_salessrno,
    //   vac_userid: localStorage.getItem("UserID"),
    //   bint_ci: localStorage.getItem("CI"),
    // };

    // const jsonString = JSON.stringify({ salesInfo });
    // console.log("jsonString", jsonString);
    // navigator.clipboard
    //   .writeText('"RTW" ' + jsonString)
    // .then(() => {
    this.trimFormData(() => {
      this.saveSales(false, () => {
        const salesInfo = {
          bint_acid: localStorage.getItem("acid"),
          bint_acyear: localStorage.getItem("ACY"),
          vac_billno: this.state.formData.LblBillNo,
          edit_salessrno: this.state.formData.edit_salessrno,
          vac_userid: localStorage.getItem("logInID"),
          bint_ci: localStorage.getItem("CI"),
        };

        const jsonString = JSON.stringify({ salesInfo });
        // console.log("jsonString", jsonString);
        navigator.clipboard.writeText('"RTW" ' + jsonString);
      });
    });
    // })
    // .catch((error) => {
    //   console.error("Error copying to clipboard:", error);
    // });
  };

  openRichTextBox = (Heading, id, TxtChange) => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Set"
          fullscreenOnly={true}
          alertIcon=""
          alertTitle={Heading}
          alertMessage={
            <MoreInfoTextEditor
              TxtChange={TxtChange}
              Txtid={id}
              updateDetails={this.updateDetails}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  updateDetails = (id, Details) => {
    let txtRemark = this.state.formData.txtRemark;

    if (id === "Remark") {
      txtRemark = Details;
    }

    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtRemark,
        },
      },
      () => {},
    );
  };

  handleCloseValidUnit = () => {
    this.setState({
      openValidUnitList: false,
    });
  };

  eWayBillDataCall = () => {
    if (
      this.validateSales() &&
      this.validateSalesItemCount() &&
      this.validatePaymentModeAmount()
    ) {
      let openSalesEway = true,
        invalidUnitMsg = "";

      this.state.rows.forEach((row) => {
        const ValidUnit = this.state.ValidUnit.some(
          (unit) => unit.shortName.toUpperCase() === row.vac_unit.toUpperCase(),
        );
        if (!ValidUnit) {
          openSalesEway = false;
          invalidUnitMsg += `Sales Item S.N. ${row.bint_itemsrno} has an invalid packing unit: "${row.vac_unit}".</br>`;
        }
      });

      const handleOpenValidUnit = () => {
        this.setState({
          openValidUnitList: true,
        });
      };

      let ARDMsg = (
        <>
          <div>
            {/* <CtBtn
              label={"Valid E-way bill Unit List"}
              onClick={handleOpenValidUnit}
            /> */}
            <Button
              variant="outlined"
              startIcon={<Info />}
              onClick={handleOpenValidUnit}
            >
              Valid E-way bill Unit List
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              padding: "10px",
              backgroundColor: "#f9f9f9",
              borderLeft: "4px solid rgb(243, 33, 33)",
              borderRadius: "4px",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                color: "#333",
                lineHeight: "1.6",
              }}
              dangerouslySetInnerHTML={{ __html: invalidUnitMsg }}
            />
          </div>
        </>
      );

      console.log("openSalesEway", openSalesEway);
      if (openSalesEway == true) {
        if (
          this.state.formData.subSupplyType &&
          this.state.formData.subSupplyType !== null
        ) {
          this.setState({ ARD: null }, () => {
            let CustomerData = this.state.Customer.find(
              (row) => row.vac_customer === this.state.formData.cmbCustomer,
            );
            let HsnCode =
              this.state.rows.length > 0 && this.state.rows[0].vac_hsncode;
            // console.log("CustomerData", CustomerData);
            // console.log("HsnCode", HsnCode);
            // console.log("this.state.CompanyList", this.state.CompanyList);

            let ARD = (
              <AlertResponsiveDialog
                alertMessage={
                  <SalesE_WayBill
                    EWayBillData={this.state.EWayBillData}
                    bint_acid={localStorage.getItem("acid")}
                    bint_acyear={localStorage.getItem("ACY")}
                    dat_salesdate={this.state.formData.dtpDate}
                    vac_billtype={this.state.formData.cmbBillType}
                    vac_billno={this.state.formData.LblBillNo}
                    dec_discamt={this.state.formData.txtDiscount}
                    dec_tdsamount={this.state.formData.txtTDSAmount}
                    dec_advancepayment={this.state.formData.txtAdvPayment}
                    vac_salestransactiontype={
                      this.state.formData.cmbTransactionType
                    }
                    dec_roundoff={this.state.formData.txtRoundOff}
                    dec_netpayment={this.state.formData.txtNetPayment}
                    bint_vouno={0}
                    vac_remark={this.state.formData.txtRemark}
                    vac_receiptgenerated={
                      this.state.formData.chkReceiptGenerated ? "Yes" : "No"
                    }
                    vac_referencename={this.state.formData.cmbReference}
                    dec_paidamt={0}
                    dec_remainamt={this.state.formData.dec_remainamt}
                    dec_beforetaxamt={this.state.totalBeforeTaxAmt}
                    dec_aftertaxamt={this.state.totalAfterTaxAmt}
                    bint_salessrno={this.state.formData.edit_salessrno}
                    SubSupplyType={this.state.formData.subSupplyType}
                    DocumentNo={this.state.formData.txtBillNo}
                    DocumentDate={this.state.formData.dtpDate}
                    Customer={this.state.formData.cmbCustomer}
                    ShipTo={this.state.formData.cmbShipTo}
                    Taxable={this.state.formData.txtTaxable}
                    totalAfterTaxAmt={this.state.totalAfterTaxAmt}
                    HsnCode={HsnCode}
                    CGST={this.state.formData.txtCGST}
                    SGST={this.state.formData.txtSGST}
                    IGST={this.state.formData.txtIGST}
                    GrandTotal={this.state.formData.txtGrandTotal}
                    CompanyDetails={this.state.CompanyList}
                    CustomerData={CustomerData}
                    PaymentData={this.state.PaymentData}
                    OtherDetailData={this.state.rowsOtherDetail}
                    setEwayBillARDNull={this.setEwayBillARDNull}
                  />
                }
                labelDisagree="Close"
                defaultOpenDialog={true}
                onYesClickCloseIfExeSuccessfully={true}
                maxWidthClass={"md"}
              />
            );

            this.setState({ ARD });
          });
        } else {
          this.props.toastErrorMsg(
            "Select Sub Supply Type In Setting->Invoice Setting",
          );
        }
      } else {
        this.setState({ ARD: null }, () => {
          let ARD = (
            <AlertResponsiveDialog
              alertTitle={"Invalid Packing Unit For E-Way Bill"}
              alertMessage={ARDMsg}
              labelDisagree="Ok"
              defaultOpenDialog={true}
              onYesClickCloseIfExeSuccessfully={true}
              maxWidthClass={"md"}
            />
          );

          this.setState({ ARD });
        });
      }
    }
  };

  //#endregion Function

  render() {
    let DisableTransactionType = false;
    let validPackingList = (
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <thead>
          <tr
            style={{
              backgroundColor: "#f2f2f2",
              borderBottom: "2px solid #000",
            }}
          >
            <th
              style={{
                border: "1px solid #000",
                padding: "8px",
                textAlign: "left",
              }}
            >
              Unit
            </th>
            <th
              style={{
                border: "1px solid #000",
                padding: "8px",
                textAlign: "left",
              }}
            >
              Valid Short Unit
            </th>
          </tr>
        </thead>
        <tbody>
          {this.state.ValidUnit.map((row, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
              <td style={{ border: "1px solid #000", padding: "8px" }}>
                {row.FullName}
              </td>
              <td style={{ border: "1px solid #000", padding: "8px" }}>
                {row.shortName}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );

    if (
      this.state.formData.cmbTransactionType === "Remain" &&
      Number(this.state.formData.dec_remainamt) !=
        Number(this.state.formData.txtNetPayment)
    ) {
      DisableTransactionType = true;
    } else {
      DisableTransactionType = false;
    }

    // console.log("this.state.Rows", this.state.rows);
    // console.log(
    //   "this.state.Rows.vac_orderitemno",
    //   this.state.rows.vac_orderitemno
    // );
    // console.log("this.state.LedgerNameList", this.state.LedgerNameList);
    // if (this.state.LedgerNameList && this.state.LedgerNameList[0]) {
    //   console.log(
    //     "this.state.LedgerNameList[0].vac_ledgername",
    //     this.state.LedgerNameList[0].vac_ledgername
    //   );
    // }
    // const rows = this.state.searchOpen
    //   ? this.state.searchRows
    //   : this.state.rows;
    // // console.log("rows", rows);
    // const rowsCount = this.state.searchOpen
    //   ? this.state.searchRowsCount
    //   : this.state.rowsCount;

    const payRemarkLblVisible = this.getPayRemarkLblVisibleStatus()
      ? "block"
      : "none";

    const isPaymodePaid = this.getPaymentModeDataStatus();
    const isDisplaySales = this.setSaveBtnDisplay();
    // console.log("this.state.formData.cmbTransactionType", this.state.formData.cmbTransactionType);
    const txtAmount4PaymentModeTable =
      this.state.formData.cmbTransactionType === "Paid"
        ? Number(this.state.formData.txtNetPayment)
        : Number(this.state.formData.txtAdvPayment);
    let DefaultEntrySettingList = this.getDefaultEntrySettingRow();
    // console.log('!@# : txtAmount4PaymentModeTable', txtAmount4PaymentModeTable)
    // console.log("this.state.formData.tblCGST", this.state.formData.tblCGST);
    // console.log("this.state.formData.tblSGST", this.state.formData.tblSGST);
    // console.log("this.state.formData.tblIGST", this.state.formData.tblIGST);
    let rowsTotal = getRowColSum(this.state.rows, [
      "dec_cgstamt",
      "dec_sgstamt",
      "dec_igstamt",
    ]);

    /* let CGST =
      Number(this.state.formData.txtCGST) + Number(this.state.formData.tblCGST);
    let SGST =
      Number(this.state.formData.txtSGST) + Number(this.state.formData.tblSGST);
    let IGST =
      Number(this.state.formData.txtIGST) + Number(this.state.formData.tblIGST); */

    let CGST =
      Number(this.state.formData.txtCGST) != 0
        ? Number(this.state.formData.txtCGST)
        : Number(rowsTotal.dec_cgstamt) + Number(this.state.formData.tblCGST);
    let SGST =
      Number(this.state.formData.txtSGST) != 0
        ? Number(this.state.formData.txtSGST)
        : Number(rowsTotal.dec_sgstamt) + Number(this.state.formData.tblSGST);
    let IGST =
      Number(this.state.formData.txtIGST) != 0
        ? Number(this.state.formData.txtIGST)
        : Number(rowsTotal.dec_igstamt) + Number(this.state.formData.tblIGST);
    let txtGrandTotal =
      Number(this.state.formData.txtTaxable) +
      Number(this.state.totalBeforeTaxAmt) +
      CGST +
      SGST +
      IGST +
      Number(this.state.totalAfterTaxAmt);
    txtGrandTotal = txtGrandTotal.toFixed(2);

    let NetPayment =
      Number(txtGrandTotal) -
      Number(this.state.formData.txtTDSAmount) -
      Number(this.state.formData.txtAdvPayment);

    let arrNetPayment = getRoundOff(NetPayment);
    NetPayment = arrNetPayment["roff_number"];
    let txtRoundOff = arrNetPayment["roff"];

    // NetPayment =
    //   Number(txtGrandTotal) -
    //   Number(this.state.formData.txtTDSAmount) -
    //   Number(this.state.formData.txtAdvPayment) +
    //   Number(txtRoundOff);

    // console.log("this.state.formData.tblCGST", this.state.formData.tblCGST);
    // console.log("this.state.formData.txtSGST", this.state.formData.txtSGST);
    // console.log("CGST", CGST);
    // console.log("SGST", SGST);
    // console.log("this.state.CustomerStateCode", this.state.CustomerStateCode);
    return (
      <div>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Sales Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="space-evenly"
          alignItems="flex-start"
          spacing={2}
          marginTop={0}
        >
          <Grid item sm={12} lg={6}>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtDtp
                  id="dtpDate"
                  label="Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpDate}
                  value={this.state.formData.dtpDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                />
              </Grid>
              <Grid item>
                <CtCmb
                  id="cmbBillType"
                  label="Bill Type*"
                  value={this.state.formData.cmbBillType}
                  handleOnChange={this.handleOnChange}
                  items={this.state.BillNoList}
                  width={120}
                  maxLength={20}
                  colID="vac_invoicetype"
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid>
              <Grid
                item
                display={
                  this.state.SalesInvoiceGeneration == "Manually"
                    ? "block"
                    : "none"
                }
              >
                <CtTxtNum
                  id="txtBillNo"
                  label="Bill No*"
                  // disabled={true}
                  value={this.state.formData.txtBillNo}
                  handleOnChange={this.handleOnChange}
                  width={80}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid>
              <Grid
                item
                display={
                  this.state.SalesInvoiceGeneration == "Manually"
                    ? "block"
                    : "none"
                }
              >
                <CtBtn
                  label={<RefreshOutlined />}
                  onClick={this.generateBillNo}
                />
              </Grid>
              <Grid item>
                <label>{this.state.formData.LblBillNo}</label>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbCustomer"
                  label="Customer*"
                  items={this.state.Customer}
                  value={this.state.formData.cmbCustomer}
                  handleOnChange={this.handleOnChange}
                  width={250}
                  maxLength={100}
                  colID="vac_customer"
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Customer == "A" ? true : false
                  }
                  onAddClick={this.onAddClickCustomer}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbShipTo"
                />
              </Grid>
              <Grid
                item
                display={this.state.Displaybtn === true ? "block" : "none"}
              >
                <CtBtn label="Order Selection" onClick={this.OrderSelection} />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbShipTo"
                  label="Ship To"
                  items={this.state.ShipTo}
                  value={this.state.formData.cmbShipTo}
                  handleOnChange={this.handleOnChange}
                  width={250}
                  maxLength={100}
                  colID="vac_customer"
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Customer == "A" ? true : false
                  }
                  onAddClick={this.onAddClickCustomer}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbReference"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbReference"
                  label="Reference"
                  items={this.state.ReferenceList}
                  value={this.state.formData.cmbReference}
                  handleOnChange={this.handleOnChange}
                  width={250}
                  maxLength={100}
                  colID="vac_referencename"
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Reference &&
                    this.props.userPrivilege.Reference == "A"
                      ? true
                      : false
                  }
                  onAddClick={this.onAddClickReference}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtDiscountAmount"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtDiscount"
                  label="Dis. Amt"
                  handleOnChange={this.handleOnChange}
                  width={100}
                  maxLength={10}
                  value={this.state.formData.txtDiscount}
                  onKeyDown={this.props.onKeyDown}
                  disabled={true}
                  nextCtrlID="txtTDSAmount"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtTaxable"
                  label="Taxable"
                  handleOnChange={this.handleOnChange}
                  width={100}
                  maxLength={10}
                  disabled={true}
                  value={this.state.formData.txtTaxable}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="beforTax"
                  label="Before Tax Amount"
                  handleOnChange={this.handleOnChange}
                  width={140}
                  maxLength={10}
                  disabled={true}
                  value={this.state.totalBeforeTaxAmt}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtCGST"
                  label="CGST"
                  handleOnChange={this.handleOnChange}
                  width={100}
                  maxLength={10}
                  disabled={true}
                  value={CGST}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtSGST"
                  label="SGST"
                  handleOnChange={this.handleOnChange}
                  width={100}
                  maxLength={10}
                  disabled={true}
                  value={SGST}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtIGST"
                  label="IGST"
                  handleOnChange={this.handleOnChange}
                  width={100}
                  maxLength={10}
                  disabled={true}
                  value={IGST}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="afterTax"
                  label="After Tax Amount"
                  handleOnChange={this.handleOnChange}
                  width={140}
                  maxLength={10}
                  disabled={true}
                  value={this.state.totalAfterTaxAmt}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtGrandTotal"
                  label="Grand Total"
                  value={txtGrandTotal}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  maxLength={10}
                  disabled={true}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtTDSAmount"
                  label="TDS Amount"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtTDSAmount}
                  width={110}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtAdvPayment"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtAdvPayment"
                  label="Adv Payment"
                  value={this.state.formData.txtAdvPayment}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  maxLength={15}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbTransactionType"
                  disabled={!this.getEnabledAdvPaymentStatus()}
                />
              </Grid>
              <Grid item>
                <CtCheckBox
                  id="chkReceiptGenerated"
                  label="Receipt Generated?"
                  checked={this.state.formData.chkReceiptGenerated}
                  handleCheckChange={this.handleOnChkChange}
                  disabled={!this.getAdvancePaidAccessStatus()}
                  // onKeyDown={this.props.onKeyDown}
                  // nextCtrlID="txtTermsAndConditionLine1"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtRoundOff"
                  label="R.Off"
                  value={txtRoundOff}
                  handleOnChange={this.handleOnChange}
                  width={60}
                  maxLength={10}
                  disabled={true}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtNetPayment"
                  label="Net Payment"
                  value={NetPayment}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  maxLength={10}
                  disabled={true}
                />
              </Grid>
              <Grid item>
                <CtCmb
                  id="cmbTransactionType"
                  label="Transaction Type*"
                  items={this.state.TransactionType}
                  value={this.state.formData.cmbTransactionType}
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={100}
                  colID="name"
                  disabled={DisableTransactionType}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              {/* <CtMultiLineText
                  id="txtRemark"
                  label="Remark"
                  value={this.state.formData.txtRemark}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={500}
                /> */}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: "#666666",
                    margin: "0",
                    padding: "0",
                    fontSize: "14px",
                  }}
                >
                  Remark
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "0",
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.formData.txtRemark,
                    }}
                    style={{ margin: "0", padding: "0" }}
                  />
                  <div style={{ margin: "0", padding: "0" }}>
                    <Edit
                      className={"child-button"}
                      style={{
                        border: "none",
                        cursor: "pointer",
                        // color: "#4687FF",
                      }}
                      onClick={() => {
                        this.openRichTextBox(
                          "Remark",
                          "Remark",
                          this.state.formData.txtRemark,
                        );
                      }}
                    />
                  </div>
                </div>
              </Grid>

              <Grid item>
                <CtTxt
                  id="txtACKDate"
                  label="ACK Date"
                  value={this.state.formData.txtACKDate}
                  handleOnChange={this.handleOnChange}
                  width={220}
                  maxLength={10}
                  disabled={true}
                />
              </Grid>
              <Grid item lg={6.7}>
                <CtMultiLineText
                  id="txtACKno"
                  label="ACK No."
                  value={this.state.formData.txtACKno}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={10}
                  disabled={true}
                />
              </Grid>

              <Grid item lg={11}>
                <CtMultiLineText
                  id="txtIRN"
                  label="IRN"
                  value={this.state.formData.txtIRN}
                  handleOnChange={this.handleOnChange}
                  width={"100%"}
                  maxLength={10}
                  disabled={true}
                />
              </Grid>
            </Grid>
            {isPaymodePaid === false ? (
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                marginTop={0}
              >
                <Grid item display={isDisplaySales}>
                  <CtBtn
                    label="Save"
                    onClick={() => {
                      this.trimFormData(() => {
                        this.saveSales(false);
                      });
                    }}
                  />
                </Grid>
                <Grid item display={isDisplaySales}>
                  <CtBtn
                    label="Print Invoice"
                    onClick={() => {
                      this.trimFormData(() => {
                        this.saveSales(true);
                      });
                    }}
                  />
                </Grid>
                <Grid item display={isDisplaySales}>
                  <CtBtn label="E-Invoice" onClick={this.handleInvoice} />
                </Grid>
                <Grid item display={isDisplaySales}>
                  <CtBtn
                    label="E-Way Bill Data"
                    onClick={this.eWayBillDataCall}
                  />
                </Grid>

                {/* <Grid item display={isDisplaySales}>
                  <CtBtn
                    label="E-Way Bill"
                    onClick={() => {
                      this.trimFormData(() => {
                        this.ewaybillprocess();
                      });
                    }}
                  />
                </Grid> */}
                <Grid item>
                  <CtBtn label="New" onClick={this.clearInfo} />
                </Grid>
                <Grid
                  item
                  display={
                    this.props.userPrivilege.Sales !== "M" ? "none" : "block"
                  }
                >
                  <CtBtn label="Delete" onClick={this.onDeleteBtnClick} />
                </Grid>
                {/* <Grid item>
                <CtBtn label="Payment Mode" onClick={this.onPaymentModeClick} />
              </Grid> */}
                <Grid item>
                  <CtBtn
                    label="Sales List"
                    onClick={() => {
                      this.props.navigateTo("SalesList");
                    }}
                  />
                </Grid>
                {/* </Grid> */}
                {/* </Grid> */}
              </Grid>
            ) : (
              ""
            )}
          </Grid>
          <Grid item sm={12} lg={6}>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                {this.state.formData.cmbCustomer.length > 0 ? (
                  <TableList
                    columns={this.state.columnsOtherDetail}
                    counter={this.state.counter}
                    rows={this.state.rowsOtherDetail}
                    rowsCount={this.state.rowsCountOtherDetail}
                    rowsPerPage={this.state.rowsPerPageOtherDetail}
                    handleChangeRowsPerPage={
                      this.handleChangeRowsPerPageOtherDetail
                    }
                    handleOnRowDataChange={
                      this.handleOnRowDataChangeOtherDetail
                    }
                    // onKeyDown={this.handleTableEnter}
                  />
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {isPaymodePaid === true ? (
          <>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={2}
              marginTop={0}
            >
              <Grid
                item
                style={{
                  color: "red",
                  fontWeight: "bolder",
                  display: payRemarkLblVisible,
                }}
              >
                *Enter Payment Mode details in bellow table for Advance Payment
                Amount.
              </Grid>
              <Grid item>
                <PaymentModeTable
                  DefaultEntrySettingList={DefaultEntrySettingList}
                  PaymentData={this.state.PaymentData}
                  PaymentLedgerNameList={this.state.rowsPaymentMode}
                  Edit_SrNo={this.state.formData.edit_salessrno}
                  setPaymentData={this.setPaymentData}
                  txtAmount={txtAmount4PaymentModeTable}
                />
                {/* <TableList
                  columns={this.state.columnsPaymentMode}
                  counter={this.state.counter}
                  rows={this.state.rowsPaymentMode}
                  rowsCount={this.state.rowsCountPaymentMode}
                  rowsPerPage={this.state.rowsPerPagePaymentMode}
                  handleChangeRowsPerPage={
                    this.handleChangeRowsPerPagePaymentMode
                  }
                  handleOnRowDataChange={this.handleOnRowDataChangePaymentMode}
                /> */}
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item display={isDisplaySales}>
                <CtBtn
                  label="Save"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.saveSales(false);
                    });
                  }}
                />
              </Grid>
              <Grid item display={isDisplaySales}>
                <CtBtn
                  label="Print Invoice"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.saveSales(true);
                    });
                  }}
                />
              </Grid>
              <Grid item display={isDisplaySales}>
                <CtBtn label="E-Invoice" />
              </Grid>

              <Grid item>
                <CtBtn label="New" onClick={this.clearInfo} />
              </Grid>
              <Grid
                item
                display={
                  this.props.userPrivilege.Sales !== "M" ? "none" : "block"
                }
              >
                <CtBtn label="Delete" onClick={this.onDeleteBtnClick} />
              </Grid>
              {/* <Grid item>
                <CtBtn label="Payment Mode" onClick={this.onPaymentModeClick} />
              </Grid> */}
              <Grid item>
                <CtBtn
                  label="Sales List"
                  onClick={() => {
                    this.props.navigateTo("SalesList");
                  }}
                />
              </Grid>
            </Grid>
          </>
        ) : (
          ""
        )}
        <br />
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={this.state.rows}
          rowsCount={this.state.rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          provideSearch={true}
          handleOnNewEntryClick={() => {
            this.trimFormData(this.handleOnNewEntryClick);
          }}
        />

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
        <Grid item>
          <Dialog
            open={this.state.openValidUnitList}
            onClose={this.handleCloseValidUnit}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Valid E-Way Bill Unit List"}
            </DialogTitle>
            <DialogContent>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "12px",
                  fontWeight: "bold",
                  color: "red",
                }}
              >
                Note: Use only the "Valid Short Unit" listed below for each
                Sales Item's Packing Unit.
              </Typography>
              <DialogContentText id="alert-dialog-description">
                {validPackingList}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseValidUnit}>Ok</Button>
            </DialogActions>
          </Dialog>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(SalesEntry))));
